import {VariableTypeEnum} from './Types'

import type {ThemeVariableObj} from './Types'

export const colors: ThemeVariableObj[] = [
  {
    name: '--glyph-glyph-brand',
    value: 'var(--color-neutral-100)',
    description: 'FilledBrand/OverlayBrand button text color, Wizard-Counter/Teaser/Checkbox input text color',
    type: VariableTypeEnum.COLOR,
  },
  // {
  //   name: '--glyph-glyph-primary',
  //   value: 'var(--color-neutral-5)',
  //   description: 'Main text color',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--glyph-glyph-secondary',
  //   value: 'var(--color-neutral-40)',
  //   description: 'Secondary text color',
  //   type: VariableTypeEnum.COLOR,
  // },
  {
    name: '--color-null',
    value: '255 255 255',
    description: 'Flat buttons background, outline disabled and inversed outline disabled',
    type: VariableTypeEnum.COLOR,
  },
  // {
  //   name: '--color-accent-50',
  //   value: '45 155 240',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  {
    name: '--color-brand-30',
    value: '36 125 194',
    description: 'FilledBrand button pressed background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-brand-40',
    value: '42 143 222',
    description: 'FilledBrand button hovered background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-brand-50',
    value: '45 155 240',
    description: 'FilledBrand/OverlayBrand button default background color',
    type: VariableTypeEnum.COLOR,
  },
  // {
  //   name: '--color-informative-20',
  //   value: '17 86 140',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-informative-50',
  //   value: '45 155 240',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-negative-30',
  //   value: '190 54 46',
  //   description: 'NOT USED feedback-glyph-semantic-negative',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-negative-50',
  //   value: '208 45 35',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  {
    name: '--color-neutral-0',
    value: '13 14 15',
    description: 'Textlink default/hovered/pressed/visited states, Filled/Overlay/Outline button default/hovered/pressed background color, primary scrim background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-5',
    value: '37 40 43',
    description: 'Filled button hover background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-20',
    value: '64 69 74',
    description: 'Filled button active background color',
    type: VariableTypeEnum.COLOR,
  },
  // {
  //   name: '--color-neutral-40',
  //   value: '118 126 133',
  //   description: 'NOT USED ... interactive-glyph-default-inactive',
  //   type: VariableTypeEnum.COLOR,
  // },
  {
    name: '--color-neutral-50',
    value: '144 159 171',
    description: 'Outline button hover/active border color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-60',
    value: '181 191 199',
    description: 'Button and TextLink disabled state text, Outline button hovered/pressed background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-70',
    value: '206 212 217',
    description: 'Outline button border color, Filled/FilledBrand/Overlay/OverlayBrand button disabled background color, Flat button pressed background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-75',
    value: '218 222 227',
    description: 'Accordion border color, AppDownload divider/border color, Award border color, KeyFact/LeyFactSmall border color, KeyValueTable, Kpi Item (underline), Quote, VideoCard border, Flat button hover background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-80',
    value: '230 234 237',
    description: 'Outline button disabled border color, Video background, TableOfContent Dropdown active background, Image Skeleton background, Dialog Aside background',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-90',
    value: '242 244 245',
    description: 'Overlay background, TableOfContent Dropdown background',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-neutral-100',
    value: '255 255 255',
    description: 'Section Background (surface-primary), Tooltip title text, FilledInversed/FilledBrand/OverlayBrand spinner, Filled/OutlineInversed/Overlay text color, OutlineInversed hover/active text color, TextLink inversed default/hovered/pressed text color, FilledInversed button default/hover/active/disabled background color, OutlineInversed button hover/active background color, OverlayInversed default/hover/active/disabled background color',
    type: VariableTypeEnum.COLOR,
  },
  {
    name: '--color-null',
    value: '255 255 255',
    description: 'Flat button background, Flat/Outline/OutlineInversed button disabled background',
    type: VariableTypeEnum.COLOR,
  },
  // {
  //   name: '--color-positive-30',
  //   value: '28 135 12',
  //   description: 'NOT USED feedback-glyph-semantic-positive',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-positive-50',
  //   value: '41 151 24',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-warning-30',
  //   value: '193 101 3',
  //   description: 'NOT USED feedback-glyph-semantic-warning',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-warning-50',
  //   value: '224 123 40',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-10',
  //   value: '255 255 255',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-20',
  //   value: '255 255 255',
  // eslint-disable-next-line max-len
  //   description: 'FilledInversed/OutlineInversed/OverlayInversed disabled text, OutlineInversed disabled border color, TextLink inversed text color',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-40',
  //   value: '255 255 255',
  //   description: 'Outline Inversed border color',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-60',
  //   value: '255 255 255',
  //   description: 'OutlineInversed hover/pressed border color',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-80',
  //   value: '255 255 255',
  //   description: 'Tooltip body text, TextLink inversed visited',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-90',
  //   value: '255 255 255',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
  // {
  //   name: '--color-inversed-100',
  //   value: '255 255 255',
  //   description: 'NOT USED',
  //   type: VariableTypeEnum.COLOR,
  // },
]

export const fonts: ThemeVariableObj[] = [
  {
    name: '--font-heading',
    value: "'Work Sans', 'Open Sans', Verdana, sans-serif",
    description: 'Heading Font',
    type: VariableTypeEnum.INDEX,
  },
  {
    name: '--font-body',
    value: "'Work Sans', 'Open Sans', Verdana, sans-serif",
    description: 'Body Font',
    type: VariableTypeEnum.INDEX,
  },
  // {
  //   name: '--font-feature-settings',
  //   value: 'normal',
  //   description: '',
  //   type: VariableTypeEnum.NONE,
  // },
  // {
  //   name: '--font-body-p1-emphasized-font-family',
  //   value: 'var(--font-body)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-body-p1-font-family',
  //   value: 'var(--font-body)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-body-p2-emphasized-font-family',
  //   value: 'var(--font-body)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-body-p2-font-family',
  //   value: 'var(--font-body)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-body-p3-emphasized-font-family',
  //   value: 'var(--font-body)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-body-p3-font-family',
  //   value: 'var(--font-body)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-display-d1-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-heading-h1-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-heading-h2-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-heading-h3-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-heading-h3-nested-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-heading-h4-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-small-display-d1-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-small-heading-h1-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-small-heading-h2-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-small-heading-h3-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-small-heading-h3-nested-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
  // {
  //   name: '--font-small-heading-h4-font-family',
  //   value: 'var(--font-heading)',
  //   description: '',
  //   type: VariableTypeEnum.REFERENCE,
  // },
]

export const radius: ThemeVariableObj[] = [
  {name: '--radius-0', value:'0px', description: '', type: VariableTypeEnum.DIMENSION},
  {name: '--radius-sm', value:'4px', description: '', type: VariableTypeEnum.DIMENSION},
  {name: '--radius-md', value:'8px', description: '', type: VariableTypeEnum.DIMENSION},
  {name: '--radius-lg', value:'16px', description: '', type: VariableTypeEnum.DIMENSION},
  {name: '--radius-interactive-sm', value:'0px', description: '', type: VariableTypeEnum.DIMENSION},
  {name: '--radius-interactive-md', value:'0px', description: '', type: VariableTypeEnum.DIMENSION},
  {name: '--radius-interactive-lg', value:'0px', description: '', type: VariableTypeEnum.DIMENSION},
]
